<div class="login-wrapper">
  <div class="login-container">
    <!-- Logo/Header -->
    <div class="login-header">
      <h1 class="login-title">{{ 'forgotPassword.title' | transloco }}</h1>
      <p class="login-subtitle" *ngIf="!isSuccess">{{ 'forgotPassword.subtitle' | transloco }}</p>
    </div>
    
    <!-- Form -->
    <form (ngSubmit)="onSubmit()" class="login-form" *ngIf="!isSubmitted && !isSuccess">
      <div class="form-group">
        <label for="email" class="form-label">
          <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 00-8 0 4 4 0 004 4h4a4 4 0 004-4z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14a9 9 0 01-9-9 9 9 0 019 9"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l-3-3m3 3l3-3m-3 3v6"></path>
          </svg>
          {{ 'forgotPassword.email' | transloco }}
        </label>
        <input
          id="email"
          type="email"
          class="form-input"
          [(ngModel)]="email"
          name="email"
          [placeholder]="'forgotPassword.emailPlaceholder' | transloco"
          [class.error]="emailError"
          [disabled]="isLoading"
          required />
        <span *ngIf="emailError" class="error-message">{{ emailError }}</span>
      </div>
  
      <button type="submit" class="btn btn-primary btn-submit" [disabled]="isLoading">
        <span *ngIf="!isLoading">{{ 'forgotPassword.sendLink' | transloco }}</span>
        <span *ngIf="isLoading">{{ 'forgotPassword.sending' | transloco }}</span>
        <svg *ngIf="!isLoading" class="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
        </svg>
      </button>

      <button type="button" (click)="goToLogin()" class="btn btn-link" [disabled]="isLoading">
        {{ 'forgotPassword.backToLogin' | transloco }}
      </button>
    </form>

    <!-- Success Message - Só aparece se a chamada à API for bem-sucedida -->
    <div *ngIf="isSuccess" class="success-message">
      <svg class="success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="success-text">{{ 'forgotPassword.successText' | transloco }}</p>
      <div class="success-link-container">
        <a (click)="goToLogin()" class="success-link">{{ 'forgotPassword.backToLogin' | transloco }}</a>
      </div>
    </div>
  </div>
  <ngx-spinner [size]="'medium'" type="ball-grid-pulse"></ngx-spinner>
</div>
